import { ThemeProvider } from "react-jss";
import { useEffect, useMemo } from "react";
import { RouterProvider } from "react-router-dom";

import { router } from "./routes";
import { useAppDispatch, useAppSelector } from "./components/hooks";
import { ApolloProvider } from "@apollo/client";
import { HtmlGameProvider } from "@onmo/html-game";
import { createApolloClient } from "@onmo/graphql";
import { selectAuthReady } from "@onmo/auth";


function App() {
  const theme = useAppSelector((state) => state.theme);
  const authReady = useAppSelector(selectAuthReady);
  const apolloClient = useMemo(() => {
    return createApolloClient();
    // Need authReady because we need to get the token
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authReady]);

  return (
    <ThemeProvider theme={theme.theme}>
      <ApolloProvider client={apolloClient}>
        <HtmlGameProvider>
          <RouterProvider router={router} />
        </HtmlGameProvider>
      </ApolloProvider>
    </ThemeProvider>
  );
}

export default App;
